import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

const REASONS = [
  { v: "counterfeit", l: "Selling counterfeit / fake goods" },
  { v: "spam", l: "Spam / duplicate listings" },
  { v: "inappropriate", l: "Inappropriate content" },
  { v: "scam", l: "Scam / fraud" },
  { v: "other", l: "Other" },
];

export default function ReportSellerModal({ sellerId, sellerName, onClose }) {
  const [reason, setReason] = useState("counterfeit");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (description.trim().length < 10) return toast.error("Please describe the issue");
    setSaving(true);
    try {
      await api.post("/reports/seller", { seller_id: sellerId, reason, description });
      toast.success("Reported — thanks. We'll investigate.");
      onClose?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to report");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="report-seller-modal">
      <div className="bg-white border-2 border-black brutal-shadow-lg max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <div className="bg-black text-[#D4FF00] border-b-2 border-black p-4 flex items-center justify-between">
          <h3 className="font-display text-2xl">REPORT SELLER</h3>
          <button onClick={onClose} data-testid="report-seller-close" className="border-2 border-black bg-white text-black p-1"><X className="w-4 h-4" /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-4">
          <p className="font-mono-b text-xs text-black/70">Reporting <b>{sellerName || "seller"}</b></p>
          <div>
            <label className="text-xs font-mono-b font-bold uppercase">REASON</label>
            <select
              data-testid="rs-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="brutal-input w-full mt-1 uppercase"
            >
              {REASONS.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs font-mono-b font-bold uppercase">DESCRIPTION</label>
            <textarea
              data-testid="rs-description"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="brutal-input w-full mt-1"
              placeholder="What happened? Give specifics."
              required
            />
          </div>
          <button
            type="submit"
            disabled={saving}
            data-testid="rs-submit"
            className="bg-[#FF007F] text-white border-2 border-black brutal-shadow hover-nudge px-6 py-3 font-mono-b font-bold uppercase disabled:opacity-50 w-full"
          >
            {saving ? "SENDING..." : "SUBMIT REPORT"}
          </button>
        </form>
      </div>
    </div>
  );
}
